<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="oo-question">
        <span class="oo-bar oo-bar--xl"></span>
        <span class="oo-bar oo-bar--md"></span>
      </div>
      <div class="oo-grid">
        <div
          v-for="(item, i) in items"
          :key="i"
          class="oo-card"
          :class="{ '--odd': item.odd }"
          :style="{ '--card-i': i }"
        >
          <span class="oo-shape" :style="{ background: item.color }"></span>
          <span class="oo-bar oo-bar--sm"></span>
          <span v-if="item.odd" class="oo-ring"></span>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="oo-phone-q"></span>
      <div class="oo-phone-grid">
        <button
          v-for="(item, i) in items"
          :key="'p' + i"
          type="button"
          class="oo-phone-card"
          :class="{ '--selected': i === 2 }"
          :style="{ '--card-i': i }"
          tabindex="-1"
        >
          <span class="oo-shape" :style="{ background: item.color }"></span>
        </button>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewOddOneOut',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
  data() {
    return {
      items: [
        { color: 'rgba(15, 15, 20, 0.18)', odd: false },
        { color: 'rgba(15, 15, 20, 0.18)', odd: false },
        { color: 'var(--accent)', odd: true },
        { color: 'rgba(15, 15, 20, 0.18)', odd: false },
      ],
    }
  },
})
</script>

<style scoped lang="scss">
.oo-bar {
  display: block; height: 7px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.oo-bar--xl { width: 70%; height: 8px; background: rgba(15, 15, 20, 0.2); }
.oo-bar--md { width: 45%; }
.oo-bar--sm { width: 70%; height: 5px; }

.oo-question {
  display: flex; flex-direction: column; gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.oo-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  flex: 1;
}
.oo-card {
  position: relative;
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.08);
  border-radius: 8px;
  padding: 12px 8px;
  display: flex; flex-direction: column; align-items: center; gap: 8px;
}
.oo-card.--odd {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 8%, white);
}
.oo-shape {
  width: 28px; height: 28px;
  border-radius: 999px;
}
.oo-ring {
  position: absolute; inset: -3px;
  border-radius: 11px;
  border: 2px solid var(--accent);
  pointer-events: none;
  animation: oo-ring 4s ease-out infinite;
}

/* ---- Audience phone ---- */
.oo-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.oo-phone-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  flex: 1;
}
.oo-phone-card {
  appearance: none;
  background: white;
  border: 1.5px solid rgba(15, 15, 20, 0.08);
  border-radius: 8px;
  padding: 12px;
  display: grid; place-items: center;
  cursor: pointer;
  aspect-ratio: 1.4 / 1;
}
.oo-phone-card.--selected {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 10%, white);
  animation: oo-tap 4s ease-out infinite;
}

@keyframes oo-ring {
  0%, 25%  { opacity: 0; transform: scale(0.85); }
  45%      { opacity: 1; transform: scale(1.05); }
  60%      { opacity: 1; transform: scale(1); }
  92%, 100% { opacity: 1; transform: scale(1); }
}
@keyframes oo-tap {
  0%, 8%   { box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 35%, transparent); }
  22%      { box-shadow: 0 0 0 8px color-mix(in srgb, var(--accent) 0%, transparent); }
  100%     { box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 0%, transparent); }
}

@media (prefers-reduced-motion: reduce) {
  .oo-ring, .oo-phone-card.--selected { animation: none; opacity: 1; transform: none; }
}
</style>
